/**
 * @desc: 校验方法
 * @created: 2020/4/16
 * @author:yeungyifan
 * @version : v1.0
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
   * @param {string} str
   * @returns {Boolean}
   */
export function validUsername(str) {
  const validMap = ['admin', 'editor']
  return validMap.indexOf(str.trim()) >= 0
}

/**
   * @param {string} str
   * @returns {Boolean}
   */
export function isNull(str) {
  return str.trim().length > 0
}

export function isRequired(schema, fields) {
  for (let key in schema) {
    if (!fields[key]) {
      return { state: false, value: key }
    }
  }

  return { state: true, value: null }
}
